import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js';

const scrollToContent = document.querySelector('.js-scroll-to-content');

if (scrollToContent) {
  scrollToContent.addEventListener('click', () => {
    const header = document.querySelector('.header');
    const content = document.querySelector('.hero + .section .section__container');
    const position = content.getBoundingClientRect().top - header.clientHeight;
    Jump(position, {
      duration: 800,
      easing: easeOutQuad,
    });
  });
}
